const style = (theme) => {
  const output = {
    root: {
      position: 'fixed',
      zIndex: 2,
      width: '86vw',
      height: 65,
      bottom: 0,
      left: '7vw',
      background: theme.colors[1],
      borderRadius: '5px 5px 0 0',
      overflow: 'hidden',
      transform: 'translateY(100%)',
      transition: `all 0.75s ${theme.easings.garret}`,
      '&.visible': {
        transform: 'translateY(0%)',
      },
    },
    toolbarNav: {
      display: 'flex',
      height: '100%',
      '& > *': {
        flex: (props) => `0 0 ${100 / props.items}%`,
        display: 'flex',
        height: '100%',
        position: 'relative',
        zIndex: 1,
        '& a, & button': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          fontSize: 10,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          transition: `all 0.4s ${theme.easings.garret}`,
          background: 'transparent',
          color: theme.getRgba(theme.colors[3], 0.3),
          cursor: 'pointer',
          '@media (hover: hover)': {
            '&:hover': {
              color: theme.getRgba(theme.colors[3], 0.5),
              background: theme.getRgba(theme.colors[6], 0.2),
            },
          },
        },
      },
    },
    active: {
      '& a, & button': {
        color: theme.colors[3],
        pointerEvents: 'none',
      },
    },
    activeBar: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: (props) => `${100 / props.items}%`,
      height: 3,
      background: theme.colors[4],
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
